import { DefaultTheme } from 'styled-components';

import { colors } from '../colors';
import { Theme } from '../types';

const theme2: DefaultTheme = {
  name: Theme.theme2,

  // Text
  fontFamily: `Inter, san-serif`,
  fontColor: colors.darkblue,
  fontWeight: 400,
  fontSize: '16px',
  fontLineHeight: '30px',
  lineHeight: 'normal',
  errorColor: colors.error,
  iconColor: colors.primary,

  // Button
  buttonFontWeight: 400,
  buttonFocusShadow: `none`,
  buttonPrimaryTextColor: colors.white,
  buttonPrimaryColor: colors.primary,
  buttonPrimaryHoverTextColor: colors.white,
  buttonPrimaryDisabledTextColor: colors.white,
  buttonPrimaryHoverColor: colors.primaryHover,
  buttonPrimaryDisabledColor: colors.primaryDisabled,
  buttonSecondaryBorderColor: colors.midnightExpress,
  buttonSecondaryColor: '#222',
  buttonSecondaryBackgroundColor: 'transparent',
  buttonSecondaryHoverColor: colors.midnightExpress,
  buttonSecondaryHoverBorderColor: colors.midnightExpress,
  buttonSecondaryDisabledColor: colors.primaryDisabled,

  // Checkbox
  checkboxColor: colors.darkblue,
  checkboxFontWeight: 400,
  checkboxBorderColor: colors.darkblue,
  checkboxBorderActiveColor: colors.darkblue,
  checkboxBackgroundColor: colors.white,
  checkboxBackgroundActiveColor: colors.darkblue,
  checkboxShadow: 'transparent',
  checkboxHover: colors.darkblue,

  // DatePicker
  datePickerShowOnlyBottomBorder: true,
  datePickerColor: colors.black,
  datePickerBorderColor: colors.midnightExpress,
  datePickerPlaceholderColor: colors.smoke,
  datePickerFocusedBorderColor: colors.midnightExpress,
  datePickerDisabledColor: colors.darkSilver,
  datePickerIconDisabledColor: colors.darkSilver,
  datePickerActiveColor: colors.primary,
  datePickerHoverActiveColor: colors.primaryHover,
  datePickerHoverShadow: 'none',
  datePickerIconColor: colors.midnightExpress,
  datePickerPadding: '7px 16px 5px',
  datePickerCalendarIconPadding: '5px',
  datePickerBackgroundColor: 'transparent',
  datePickerInputHeight: '35px',

  // Dropdown
  dropdownIconColor: colors.darkblue,

  // Footer
  footerTextColor: colors.northrend,
  footerHeadingColor: colors.edgewater,
  footerCheckIconColor: colors.primary,
  footerSocialIconColor: colors.northrend,
  footerLineColor: colors.northrend,
  footerInputErrorColor: colors.error,
  footerIconColor: colors.darkCerulean,
  footerBackgroundDark: '#12192a',
  footerBackgroundLight: '#242e47',

  // Form
  formRowLabelColor: colors.darkblue,
  formRowLabelFontSize: '20px',
  formRowLabelPadding: '0 0 54px 0',
  formRowGap: '54px',

  // Heading
  // sizes: 1, 2, 3, 4, 5, 6, 7
  headingSizes: ['64px', '56px', '36px', '30px', '24px', '20px', '16px'],
  headingLineHeight: ['68px', '60px', '48px', '36px', '30px', '30px', '30px'],
  headingMobileSizes: ['64px', '56px', '36px', '30px', '24px', '20px', '16px'],
  headingOutline: '14px',
  headingOutlineLineHeight: '24px',
  headingFontFamily: `ivypresto-headline, serif`,
  headingFontWeight: '400',

  // Link
  linkColor: colors.darkblue,
  linkHoverColor: colors.darkblue,
  linkDisabledColor: colors.primaryDisabled,

  // LinkButton
  linkButtonIconColor: colors.primary,
  linkButtonIconColorDisabled: colors.primaryDisabled,

  // Modal
  modalLineColor: colors.primary,

  // Nav
  navLinkColor: colors.darkCerulean,
  navLinkBackgroundColor: colors.darkCerulean,
  navSubMenuItemHoverBackgroundColor: colors.whiteIce,
  navMenuItemBackgroundColor: colors.whiteIce,
  navMobileSignInLinkColor: colors.darkCerulean,
  navUserIconBackgroundColor: colors.whiteIce,
  navUserIconColor: colors.darkCerulean,
  navMenuHamburgerColor: colors.darkCerulean,
  navBorderColor: colors.edgewater,

  // Navbar
  navbarColor: colors.darkblue,
  navbarColorHover: colors.darkblue,

  // PDF
  pdfControlsColor: colors.primary,
  pdfControlsDisabledColor: colors.primaryDisabled,
  pdfIconColor: colors.primary,
  pdfIconDisabledColor: colors.primaryDisabled,
  pdfControlsIconColor: colors.white,

  // Radio
  radioColor: colors.darkblue,
  radioBorderColor: colors.smoke,
  radioBorderActiveColor: colors.darkblue,
  radioBackgroundColor: colors.white,
  radioBackgroundActiveColor: colors.darkblue,
  radioShadow: 'transparent',
  radioHover: colors.darkblue,
  radioSize: 16,
  radioInputTopPosition: 2,

  // Select Input
  selectShowOnlyBottomBorder: true,
  selectShowIndicatorAnimation: true,
  selectColor: colors.black,
  selectPlaceholderColor: colors.smoke,
  selectDisabledColor: colors.darkSilver,
  selectBorderColor: colors.midnightExpress,
  selectPrimaryBorderColor: colors.midnightExpress,
  selectPrimaryHoverBorderColor: colors.midnightExpress,
  selectPrimaryFocusedBorderColor: colors.midnightExpress,
  selectPrimaryDisabledBackgroundColor: 'transparent',
  selectHoverShadow: 'none',
  selectInputPadding: '0 0 0 5px',
  selectInputBackgroundColor: 'transparent',
  selectMenuShadow: '0 2px 4px 0 rgba(217, 217, 217, 0.5)',
  selectMenuBorder: `0`,
  selectOptionPadding: '6px 16px',
  selectOptionActiveColor: colors.darkblue,
  selectDisabledBorderColor: colors.darkSilver,
  selectIndicatorIcon: 'arrow-down',
  selectIndicatorIconSize: 20,
  selectIndicatorIconViewWidth: 20,
  selectIndicatorIconViewHeight: 20,
  selectIndicatorIconColor: colors.darkblue,
  selectInputHeight: '36px',

  // Tabs
  tabsActiveColor: colors.midnightExpress,
  tabsActiveBorderColor: colors.primary,

  // Text Input
  textInputShowOnlyBottomBorder: true,
  textInputColor: colors.black,
  textInputFocusedColor: colors.black,
  textInputBorderColor: colors.midnightExpress,
  textInputFocusedBorderColor: colors.midnightExpress,
  textInputBackgroundColor: 'transparent',
  textInputHoverShadow: 'none',
  textInputPadding: '7.5px 16px',
  textInputPlaceholderColor: colors.darkSilver,
  textInputLabelColor: colors.darkblue,
  textInputNotePadding: '0 16px',
  textInputNoteFontStyle: 'italic',
  textInputDisabledBorderColor: colors.darkSilver,
  textInputDisabledColor: colors.darkSilver,
  textInputShowAnimatedLabel: false,
  textInputIconColor: colors.primary,
  textInputHeight: '36px',

  // Textarea Input
  textAreaInputTextColor: colors.ash,
  textAreaInputBorderColor: colors.midnightExpress,
  textAreaInputFocusTextColor: colors.charcoal,
  textAreaInputFocusBorderColor: colors.midnightExpress,
  textAreaInputDisabledTextColor: colors.smoke,
  textAreaInputDisabledBorderColor: colors.cloud,
  textAreaInputPlaceholderColor: colors.smoke,

  // Toggle
  toggleColor: colors.smoke,
  toggleActiveColor: colors.primary,

  // UserDropdown
  userDropdownColor: colors.primary,
  userDropdownColorHover: colors.primaryHover,

  inputErrorMessagePadding: '0 16px',
};

export default theme2;
